import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\GetPersonListController::__invoke
* @see app/Http/Controllers/Person/GetPersonListController.php
* @route '/api/person'
*/
const GetPersonListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPersonListController.url(options),
    method: 'get',
})

GetPersonListController.definition = {
    methods: ["get","head"],
    url: '/api/person',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Person\GetPersonListController::__invoke
* @see app/Http/Controllers/Person/GetPersonListController.php
* @route '/api/person'
*/
GetPersonListController.url = (options?: RouteQueryOptions) => {
    return GetPersonListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\GetPersonListController::__invoke
* @see app/Http/Controllers/Person/GetPersonListController.php
* @route '/api/person'
*/
GetPersonListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPersonListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Person\GetPersonListController::__invoke
* @see app/Http/Controllers/Person/GetPersonListController.php
* @route '/api/person'
*/
GetPersonListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPersonListController.url(options),
    method: 'head',
})

export default GetPersonListController